import { useContext, useEffect, useMemo, useRef, useState, memo } from 'react';

import { message, Spin } from 'antd';
import Cookies from 'js-cookie';
import { throttle, uniqWith } from 'lodash-es';
import dynamic from 'next/dynamic';

import {
  activityOverseaCouponTips,
  isCounponUnavailableForOversea,
  selectProductLabel,
  getMarketCouponLabelShow,
} from '@/apis/activity';
import { loadProductSeries } from '@/apis/list';
import { selectProductFavorite } from '@/apis/member';
import { overseaSloganList } from '@/apis/op';
import {
  overseasGlobalSearch,
  overseasGlobalSearchProvider,
  overseasSearch,
  searchAlias,
  searchMoreChannel,
  searchProviders,
} from '@/apis/overseas';
import { queryParamAgg, secondQueryGlobal, secondQueryMroGlobal } from '@/apis/so';
import AnchorNav from '@/components/AnchorNav';
import BrandAndCatalogNav from '@/components/BrandAndCatalogNav';
import CustomPagination from '@/components/CustomPagination';
import EmptyResult from '@/components/EmptyResult';
import EmptyText from '@/components/EmptyText';
import FilterCondition from '@/components/FilterCondition';
import FindAndStock from '@/components/FindAndStock';
import LoadMoreButton from '@/components/LoadMoreButton';
import MaybeLookTag from '@/components/MaybeLookTag';
import MixSortFilter from '@/components/MixSortFilter';
import Nav from '@/components/Nav';
import OverseasNotice from '@/components/OverseasNotice';
import OverseasItem from '@/components/ProductItem/overseasItem';
import ProductItem from '@/components/ProductItem/productItem';
import { OverseasCard } from '@/components/ProductItem/style';
import ProductList from '@/components/ProductList';
import OverseasList, { slogan2Provider } from '@/components/ProductList/overseasList';
import RiskMsgResult from '@/components/RiskMsgResult';
import SvgIcon from '@/components/SvgIcon';
import UnfoundTips from '@/components/UnFoundTips';
import { LayoutContext } from '@/layouts/baseLayout/provider';
import useUserStore from '@/store/user';
import { buriedPoint } from '@/utils/buriedPoint';
import { getPaginationInfo } from '@/utils/common';
import Utils from '@/utils/Utils';

const MarketAlertDialog = dynamic(() => import('@/components/MarketAlertDialog'));
const FloatAdvert = dynamic(() => import('@/components/FloatRightAdvert'));
const Toolbar = dynamic(() => import('@/components/ToolBar'));

const aliasMap = new Map();
const sloganMap = new Map();
const providerCache = new Map();
let moreChannelList = [];
let observer = null;
const maxObserveIndex = 5;
let overseasList = [];
let isSendViewBuriedPoint = false;
let showOsCoupon = false;

function GlobalPage(props) {
  const { resourceData } = useContext(LayoutContext);
  const {
    findAndStockContent,
    isMro,
    mainMro,
    rs_log,
    riskMsg,
    globalSearchKeyword,
    searchSource,
    showStockBtn,
    matchCatalog,
    matchBrand,
    changeIsLgScreen,
    greekCharTipList,
  } = props;
  const { userInfo } = useUserStore();
  const [searchResult, setSearchResult] = useState(props?.searchResult);
  const [paginationInfo, setPaginationInfo] = useState(props.paginationInfo);
  const [aggregateResultVO, setAggregateResultVO] = useState(null);
  const [openEnquiry, setOpenEnquiry] = useState('');

  const [providerList, setProviderList] = useState([]);
  const [moreChannelVO, setMoreChannelVO] = useState({});
  const [marketLabelVO, setMarketLabelVO] = useState({});
  const [osCoupon, setOsCoupon] = useState({});
  const [moreOsCoupon, setMoreOsCoupon] = useState({});
  const productItemRefs = useRef([]);
  const [dhAndTeAndRoCoupon, setDhAndTeAndRoCoupon] = useState({}); // 展示立创订货、te、rochester的优惠券

  const [sendSearchParams, setSendSearchParams] = useState({
    currentPage: paginationInfo?.currentPage || 1, //页码
    pageSize: 30, // 条数
    catalogIdFilter: '', // 目录
    brandIdFilter: '', // 品牌
    standardFilter: '', // 封装
    arrangeFilter: '', // 编排 也就是包装
    labelFilter: '', // 标签
    authenticationFilter: '', // 认证信息
    keyword: globalSearchKeyword, // 全局搜索关键词
    sortNumber: 0, // 0 综合 1 价格升序 2 价格降序 9 总库存升序 8 总库存降序 6 销量 10 广东库存降序 11 广东库存升序 12 江苏库存降序 13 江苏库存升序
    satisfyStockType: '', // 价格/库存筛选里面的库存
    startPrice: '', // 开始单价
    endPrice: '', // 结束单价
    demandNumber: '', // 需求数量
    spotFilter: 1, // 现货 勾选0 未勾选1
    discountFilter: 1, // 折扣 勾选0 未勾选1
    hasDataFile: false, // 数据手册 勾选true 未勾选false
    brandPlaceFilter: '', // 勾选国产品牌传中国大陆$中国台湾 勾选国际品牌传国际
    secondKeyword: '', // 二次查询关键词
    queryParameterValue: '', // 显示在更多位置的目录参数
    lastParamName: '', // 显示在更多位置的最后一个点击的目录参数
  });
  const [overseaLoading, setOverseaLoading] = useState(false); // 防止重复请求
  const [overseaLoadingFinish, setOverseaLoadingFinish] = useState(false); // 海外代购请求完成之后设置为true
  const [requestLoading, setRequestLoading] = useState(false); // 防止重复请求
  const [secondQueryIsEmpty, setSecondQueryIsEmpty] = useState(false); // 判断二次筛选是否为空 为true 则为空 需要清空筛选器的内容 且出现空提示
  const [favoriteList, setFavoriteList] = useState([]);
  const filterConditionRef = useRef(null);
  const findAndStockRef = useRef(null);
  const anchorNavRef = useRef(null);
  const [mixSortDisabled, setMixSortDisabled] = useState(false);
  const [anchorHeaderCls, setAnchorHeaderCls] = useState('');
  const [anchorHeaderShadow, setAnchorHeaderShadow] = useState('');
  const [showFilterCondition, setShowFilterCondition] = useState(props?.searchResult?.totalCount !== 1);
  const [filterConditionHover, setFilterConditionHover] = useState(false);
  const [newParameterCondition, setNewParameterCondition] = useState('');
  const [productSpuMap, setProductSpuMap] = useState({});
  const [productConnectorMap, setProductConnectorMap] = useState({});
  const [hasInit, setHasInit] = useState(false);
  const [displayCount, setDisplayCount] = useState(3); // 控制显示的商品数量，默认显示3条
  const [hasPaginated, setHasPaginated] = useState(false); // 跟踪用户是否进行过分页操作

  const navList = [
    {
      name: '首页',
      url: isMro ? resourceData?.projectConfigVO?.lcscMroUrl : resourceData?.projectConfigVO?.lcscWwwUrl,
      spm: 1,
    },
    {
      name: '搜索关键字',
      url: '',
      spm: '',
    },
  ];
  const isEmptyResult = props?.searchResult?.productRecordList?.length === 0;
  if (!riskMsg) {
    navList.push({
      name: isEmptyResult ? Utils.getSafeSearchKeyword(globalSearchKeyword) : globalSearchKeyword,
      url: '',
      spm: '',
    });
  }

  useEffect(() => {
    if (rs_log) {
      Utils.setLocal('rsLog', rs_log);
    }
    const soBuriedPointData = Cookies.get('soBuriedPointData');
    if (soBuriedPointData) {
      try {
        const obj = JSON.parse(soBuriedPointData);
        obj.data.no = searchResult?.totalCount || 0;
        obj.data.option = window.isMro ? 'MRO' : sessionStorage.getItem('main-site-search-option');
        buriedPoint(obj);
        Cookies.set('soBuriedPointData', '', {
          domain: '.szlcsc.com',
          expires: 1000 * 60 * 60 * 24 * 365,
          path: '/',
        });
      } catch (err) {
        console.warn('search埋点失败', err);
      }
    }
    init();
    window.addEventListener('scroll', handleScroll, { passive: true });
    document.body.addEventListener('click', handleClosePopover);
    handleResize();
    window.addEventListener('resize', handleResize);
    addAnchorHeaderCls();
    initHandleQueryParamAgg();
    return () => {
      observer?.disconnect();
      window.removeEventListener('scroll', handleScroll);
      document.body.removeEventListener('click', handleClosePopover);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (userInfo.customerLogin === 1) {
      setOpenEnquiry('yes');
    }
  }, [userInfo.customerLogin]);

  useEffect(() => {
    if (hasInit) {
      observerProductItem();
      handleLoadProductSeries(searchResult?.productRecordList?.length);
    }
  }, [searchResult?.productRecordList, hasInit]);

  const handleScroll = throttle(() => {
    findAndStockRef?.current?.setStarPosition();
    anchorNavRef?.current?.setAnchorNavPosition();
    addAnchorHeaderCls();
    if (productItemRefs?.current?.length > 0) {
      productItemRefs?.current.forEach((item) => {
        item?.checkButtonPosition();
      });
    }
  }, 0);

  const wrapToTop = () => {
    if (searchResult?.totalCount > 0) {
      anchorNavRef?.current?.toTop('lcxh');
    } else if (providerList.length > 0) {
      anchorNavRef?.current?.toTop(providerList[0]?.provider);
    }
  };

  const addAnchorHeaderCls = () => {
    setTimeout(() => {
      const dom = document.querySelector('#float-header');
      setAnchorHeaderCls(dom ? 'top-[72px]' : '');
      const anchorNavDom = document.querySelector('.anchor-header');
      setAnchorHeaderShadow(
        Math.ceil(anchorNavDom?.getBoundingClientRect()?.top) === 72
          ? 'shadow-[0_9px_19px_0px_rgba(13,28,51,0.15)]'
          : ''
      );
    }, 320);
  };

  const handleClosePopover = () => {
    filterConditionRef?.current?.closePopover();
  };

  const handleResize = () => {
    typeof changeIsLgScreen === 'function' && changeIsLgScreen(Utils.isLgScreen());
    findAndStockRef?.current?.setStarPosition();
  };

  // 监听商品列表是否在可视访问
  function observerProductItem() {
    if (observer) {
      observer?.disconnect();
      observer = null;
    }
    moreChannelList = searchResult?.productRecordList?.map((item) => {
      return {
        uuid: item?.productVO?.productId,
        productCode: item?.productVO?.productCode,
        productModel: item?.productVO?.productModel,
        brandId: item?.productVO?.productGradePlateId,
        brandName: item?.productVO?.productGradePlateName,
      };
    });
    getFavoriteList();
    const cacheList = []; // 记录请求过的groupIndex;
    observer = new IntersectionObserver((entries) => {
      entries.forEach(
        (entry) => {
          if (entry.isIntersecting) {
            let startIndex = entry?.target?.dataset?.index;
            if (!startIndex) {
              return;
            }
            startIndex = Number(startIndex);
            if (cacheList.includes(startIndex)) {
              return;
            }
            const fetchList = [getMarketLable(startIndex)];
            // 自营商品≤3时，不显示更多渠道
            if (searchResult?.totalCount > 3) {
              fetchList.push(getMoreChannel(startIndex));
            }
            Promise.allSettled(fetchList).then(() => {
              cacheList.push(startIndex);
            });
          }
        },
        {
          rootMargin: '0px', // 不增加额外的外边距
          threshold: [0, 0.5, 1.0], // 在交集比例为 0%, 50%, 100% 时触发回调
        }
      );
    });
    document.querySelectorAll('.product-group-leader').forEach((el) => {
      observer.observe(el);
    });
  }

  // 获取同系列sku 配套连接器
  const handleLoadProductSeries = async (len) => {
    if (!len) return false;
    const params = {
      productCodeList: searchResult?.productRecordList.map((item) => item.productVO.productCode),
    };
    const res = await loadProductSeries(params);
    if (res?.code === 200) {
      setProductConnectorMap(res?.result?.productConnectorMap || {});
      setProductSpuMap(res?.result?.productSpuMap || {});
    }
  };

  // 获取运营标签
  function getMarketLable(startIndex) {
    const list = moreChannelList.slice(startIndex, startIndex + maxObserveIndex);
    if (list.length === 0) {
      return;
    }
    const params = list.map((item) => item.uuid);
    selectProductLabel(params).then((res) => {
      const list = res?.result;
      if (list?.length > 0) {
        const obj = {};
        list.forEach((item) => {
          obj[item?.productId] = item;
        });
        setMarketLabelVO((prev) => ({
          ...prev,
          ...obj,
        }));
      }
    });
  }

  // 获取收藏列表
  function getFavoriteList() {
    if (moreChannelList.length === 0) {
      return;
    }
    const productIds = moreChannelList.map((item) => item.uuid).join();
    selectProductFavorite({ productIds })
      .then((res) => {
        setFavoriteList(res?.result?.map((item) => item.toString()) || []);
      })
      .catch((error) => {
        console.error('获取收藏列表失败', error);
      });
  }

  function init() {
    buriedPoint({
      ty: 'enter',
      op: 'view',
      data: {
        pc: searchResult?.productRecordList.map((item) => item?.productVO?.productId).join(','),
      },
    });
    Utils.asyncAll([searchAlias(), overseaSloganList(), searchProviders(), isCounponUnavailableForOversea()]).then(
      ([alias, slogan, providers, ovease]) => {
        if (alias?.result?.length) {
          alias.result.forEach((item) => {
            aliasMap.set(item?.provider, item);
          });
        }
        if (slogan?.result?.length) {
          slogan.result.forEach((item) => {
            sloganMap.set(slogan2Provider[item?.provider], item);
          });
        }
        showOsCoupon = !ovease?.result;
        if (providers?.result?.length) {
          overseasList = providers?.result;
          getOverseasList();
        }
        setHasInit(true);
      }
    );
  }

  // 获取海外代购优惠券
  function getOsCoupon(providerList) {
    const list = [];
    providerList.forEach((provider) => {
      if (!Utils.isLcBook(provider?.provider) && provider?.products?.length > 0) {
        provider.products.forEach((product) => {
          list.push({
            provider: product.provider,
            brandId: product.brandId,
          });
        });
      }
    });
    setOverseaCoupon(list, false);
  }

  function getOverseasList(brandPlaceFilter) {
    if (overseaLoading) {
      return;
    }
    setOverseaLoading(true);
    let from = '';
    if (Utils.getUrlParam('from') === 'kw') {
      from = Utils.getUrlParam('from');
    } else {
      from = Utils.safeEncodeURI(searchResult?.globalSearchKeyword || '');
    }
    let brandLevel;
    if (brandPlaceFilter === '国际') {
      brandLevel = 'internation';
    } else if (brandPlaceFilter === '中国大陆$中国台湾') {
      brandLevel = 'domestic,tai';
    }
    // 海外代购
    const map = overseasList?.map((item) =>
      overseasSearch({
        keyword: searchResult?.globalSearchKeyword || '',
        providers: item.provider,
        pageNumber: 1,
        noShowSelf: false,
        from,
        brandLevel,
      })
    );
    // 立创订货
    map.unshift(
      overseasGlobalSearch({
        keyword: searchResult?.globalSearchKeyword || '',
        pageNumber: 1,
        noShowSelf: false,
        from,
        brandLevel,
      })
    );
    Utils.asyncAll(map)
      .then((resList) => {
        const filterList = resList.filter((item) => item && item?.code === 200);
        const list = [];
        let tiOvs = null;
        let teOvs = null;
        const productCodeList = [];
        filterList.forEach((res) => {
          res?.result?.forEach((item) => {
            const aliasItem = aliasMap.get(item?.provider) || {};
            const sloganItem = sloganMap.get(item?.provider) || {};
            const newItem = Object.assign({}, aliasItem, sloganItem, item);
            if (newItem?.products?.length > 0) {
              newItem.products = newItem?.products?.map((x) => {
                return {
                  ...providerItemFormat(x),
                  track_zone: item?.track_zone,
                };
              });
              if (newItem?.provider === 'ti_ovs') {
                tiOvs = newItem;
              } else if (newItem?.provider === 'te') {
                teOvs = newItem;
              } else if (newItem?.isLcscBookShow && newItem.products.length > 3) {
                providerCache.set(newItem?.provider, newItem.products.splice(3, 999));
                list.push(newItem);
              } else {
                list.push(newItem);
              }
              if (Utils.isLcBook(newItem?.provider) && Array.isArray(newItem.products) && newItem.products.length > 0) {
                productCodeList.push(
                  ...newItem.products.map((v) => {
                    return {
                      productCode: v?.productCode,
                      brandId: v?.brandId,
                    };
                  })
                );
              }
            }
          });
        });
        loadMarketCouponLabelShow(productCodeList);
        if (teOvs) {
          list.unshift(teOvs);
        }
        if (tiOvs) {
          list.unshift(tiOvs);
        }
        // 用户体验弹窗埋点数据
        if (list.length > 0) {
          const newList = [];
          for (const item of list) {
            if (item?.products.length > 0) {
              newList.push(...item.products);
            }
          }
        }
        setProviderList(list);
        getOsCoupon(list);
        if (!isSendViewBuriedPoint) {
          const kw = searchResult?.globalSearchKeyword || '';
          const data = list.map((item) => {
            const xh = item?.products?.map((x) => x?.productCodeManufacturer).join(',');
            const no = item?.products?.length;
            return {
              kw,
              type: item?.provider,
              xh,
              no,
            };
          });
          const hasLcOrder = list.some((item) => item.isLcscBookShow);
          const hasOversea = list.some((item) => !item.isLcscBookShow);
          buriedPoint({ cp: 'keyword_search_overseas', ty: 'enter', op: 'view', data });
          buriedPoint({ ty: 'enter', op: 'lcorder_view', data: { kw, show: hasLcOrder } });
          buriedPoint({ ty: 'enter', op: 'oversea_view', data: { kw, show: hasOversea } });
          isSendViewBuriedPoint = true;
        }
      })
      .finally(() => {
        setOverseaLoading(false);
        setOverseaLoadingFinish(true);
      });
  }

  const loadMarketCouponLabelShow = async (productCodeList = []) => {
    if (!productCodeList.length) return;
    const res = await getMarketCouponLabelShow(productCodeList);
    if (res?.code === 200 && res.result) {
      const dataMap = {};
      Object.keys(res.result).forEach((item) => {
        dataMap[item] = {
          ...res.result[item],
          ...(res.result[item]?.couponInfo || {}),
        };
      });
      setDhAndTeAndRoCoupon((prevState) => {
        return {
          ...prevState,
          ...dataMap,
        };
      });
    }
  };

  function getMoreProvider(provider) {
    let from = '';
    if (Utils.getUrlParam('from') === 'kw') {
      from = Utils.getUrlParam('from');
    } else {
      from = Utils.safeEncodeURI(searchResult?.globalSearchKeyword || '');
    }
    let brandLevel = '';
    if (sendSearchParams?.brandPlaceFilter === '国际') {
      brandLevel = 'internation';
    } else if (sendSearchParams?.brandPlaceFilter === '中国大陆$中国台湾') {
      brandLevel = 'domestic,tai';
    }
    const params = {
      keyword: searchResult?.globalSearchKeyword || '',
      providers: provider?.provider,
      pageNumber: provider?.pageNumber + 1,
      noShowSelf: false,
      from,
      brandLevel,
    };
    const index = providerList.findIndex((item) => item.provider === provider?.provider);
    const cb = (result) => {
      const list = [];
      if (result?.length > 0) {
        result[0].products?.forEach((item) => {
          list.push({
            provider: item?.provider,
            brandId: item?.brandId,
          });
        });
        setProviderList((old) => {
          const val = old.slice();
          val[index] = Object.assign(old[index], {
            ...result[0],
            products: [...old[index].products, ...result[0].products].map((item) => {
              return {
                ...providerItemFormat(item),
                track_zone: old[index].track_zone,
              };
            }),
          });
          return val;
        });
        buriedPoint({
          op: 'show_more',
          cp: 'overseas_list',
          data: {
            xh: result[0]?.products?.map((item) => item?.productCodeManufacturer).join(','),
            type: provider?.provider,
          },
        });
      }
      const productCodeList = [];
      result?.forEach((item) => {
        item?.products?.forEach((v) => {
          if (Utils.isLcBook(v?.provider)) {
            productCodeList.push({
              productCode: v?.productCode,
              brandId: v?.brandId,
            });
          }
        });
      });
      loadMarketCouponLabelShow(productCodeList);
      setOverseaCoupon(list, false);
    };
    const list = providerCache.get(provider?.provider);
    if (list && list.length > 0) {
      cb([{ pageNumber: provider?.pageNumber + 1, products: list.splice(0, 10) }]);
    } else if (Utils.isLcBook(provider?.provider)) {
      overseasGlobalSearch(params).then(({ result }) => cb(result));
    } else {
      overseasGlobalSearchProvider(params).then(({ result }) => cb(result));
    }
  }

  function setOverseaCoupon(list, isMore) {
    if (!showOsCoupon) {
      return;
    }
    const arr = uniqWith(list, (a, b) => a?.provider === b?.provider && a?.brandId === b?.brandId);
    if (arr.length > 0) {
      activityOverseaCouponTips(arr).then((res) => {
        if (res?.result) {
          if (isMore) {
            setMoreOsCoupon((prev) => ({
              ...prev,
              ...res?.result,
            }));
          } else {
            setOsCoupon((prev) => ({
              ...prev,
              ...res?.result,
            }));
          }
        }
      });
    }
  }

  const changeSendSearchParams = (params, needTip = true, cb) => {
    if (requestLoading) {
      return;
    }
    setRequestLoading(true);
    const updatedParams = {
      ...sendSearchParams,
      ...params,
    };
    if (updatedParams?.brandPlaceFilter !== sendSearchParams?.brandPlaceFilter) {
      getOverseasList(updatedParams.brandPlaceFilter);
    }
    setSendSearchParams(updatedParams);
    handleSecondQueryGlobal(updatedParams, needTip, cb);
  };

  const handleSecondQueryGlobal = (params = sendSearchParams, needTip = true, cb, isLoginTrigger = false) => {
    // queryParameterValue和lastParamName 未选中目录 有值可传 选中目录 只有在选中单个的情况下才传
    const queryParameterFlag =
      (params.catalogIdFilter && params.catalogIdFilter.split('$').length < 2) || !params.catalogIdFilter;
    const sendParams = {
      ...params,
      queryParameterValue:
        queryParameterFlag && params?.queryParameterValue && typeof params?.queryParameterValue === 'string'
          ? encodeURIComponent(params?.queryParameterValue.replace(/@{5}/g, '@'))
          : '',
      lastParamName: queryParameterFlag ? params?.lastParamName : '',
    };
    if (searchSource) {
      Object.assign(sendParams, {
        searchSource,
      });
    }
    window.scrollTo({
      top: 0,
      smooth: true,
    });
    // 加购链路追踪
    handleSetParameterCondition({
      ...params,
      queryParameterValue:
        queryParameterFlag && params?.queryParameterValue && typeof params?.queryParameterValue === 'string'
          ? params?.queryParameterValue
          : '',
    });
    if (mainMro) {
      delete sendParams?.hasDataFile;
      delete sendParams?.brandPlaceFilter;
    }
    const fn = isMro || mainMro ? secondQueryMroGlobal : secondQueryGlobal;
    fn(sendParams)
      .then((res) => {
        if (res?.code === 200) {
          //二次查询为空 显示对应文案 且将筛选器重置
          if (res?.result?.searchResult?.productRecordList?.length === 0) {
            if (needTip) {
              setSecondQueryIsEmpty(true);
            }
            filterConditionRef?.current?.resetAllCondition();
          } else {
            setSecondQueryIsEmpty(false);
            if (window.scrollY < 30) {
              anchorNavRef?.current?.toTop('lcxh');
            }
          }
          setSearchResult(res?.result?.searchResult);
          setOpenEnquiry(res?.result?.openEnquiry);
          const paginationInfoState = getPaginationInfo({
            currentUrl: location.href,
            currentPage: params.currentPage,
            countPage:
              res?.result?.searchResult?.countPage ||
              parseInt(res?.result?.searchResult?.totalCount / res?.result?.searchResult?.pageSize),
            totalCount: res?.result?.searchResult?.totalCount,
            pageSize: res?.result?.searchResult?.pageSize,
          });
          setPaginationInfo(paginationInfoState);
          // 如果是弹窗触发的请求，则不进行商品参数查询
          if (!isLoginTrigger) {
            // 如果选中类目只有一个的时候 需要查询商品参数
            if (sendParams.catalogIdFilter && sendParams.catalogIdFilter.split('$').length === 1) {
              handleQueryParamAgg(sendParams, 'query/product');
            } else if (!sendParams.catalogIdFilter && res?.result?.searchResult?.catalogGroup?.length === 1) {
              // 或者类目只有一个的时候 也需要查询商品参数
              handleQueryParamAgg(
                {
                  ...sendParams,
                  catalogIdFilter: res?.result?.searchResult?.catalogGroup[0]?.value,
                },
                'query/product'
              );
            } else {
              setAggregateResultVO(null);
            }
          }
        }
      })
      .catch((err) => {
        message.error(err?.msg);
      })
      .finally(() => {
        typeof cb === 'function' && cb();
        setRequestLoading(false);
      });
  };

  // 如果类目只有一个的时候 需要查询商品参数
  const initHandleQueryParamAgg = () => {
    if (props?.searchResult?.catalogGroup.length === 1) {
      const sendParams = {
        ...sendSearchParams,
        catalogIdFilter: props?.searchResult?.catalogGroup[0]?.value,
      };
      if (searchSource) {
        Object.assign(sendParams, {
          searchSource,
        });
      }
      handleQueryParamAgg(sendParams, 'query');
    }
  };

  const handleQueryParamAgg = (params, sign) => {
    queryParamAgg(params, sign).then((res) => {
      if (res?.code === 200) {
        setAggregateResultVO(res?.result);
      }
    });
  };

  const handleSetParameterCondition = (params) => {
    const newParameterConditionMap = {};
    if (params?.catalogIdFilter) {
      newParameterConditionMap['类目'] = [];
      params.catalogIdFilter.split('$').forEach((item) => {
        const obj = searchResult?.catalogGroup.find((row) => String(row.value) === String(item));
        if (obj) {
          newParameterConditionMap['类目'].push(obj?.label);
        }
      });
    }
    if (params?.brandIdFilter) {
      newParameterConditionMap['品牌'] = [];
      params.brandIdFilter.split('$').forEach((item) => {
        const obj = searchResult?.gradePlateGroup.find((row) => String(row.value) === String(item));
        if (obj) {
          newParameterConditionMap['品牌'].push(obj?.label);
        }
      });
    }
    if (params?.standardFilter) {
      newParameterConditionMap['封装'] = [];
      params.standardFilter.split('$').forEach((item) => {
        const obj = searchResult?.encapsulationGroup.find((row) => String(row.label) === String(item));
        if (obj) {
          newParameterConditionMap['封装'].push(obj?.label);
        }
      });
    }
    if (params?.arrangeFilter) {
      newParameterConditionMap['包装'] = [];
      params.arrangeFilter.split('$').forEach((item) => {
        const obj = searchResult?.arrangeGroup.find((row) => String(row.label) === String(item));
        if (obj) {
          newParameterConditionMap['包装'].push(obj?.label);
        }
      });
    }
    if (params?.labelFilter) {
      newParameterConditionMap['标签'] = [];
      params.labelFilter.split('$').forEach((item) => {
        const obj = searchResult?.labelGroup.find((row) => String(row.label) === String(item));
        if (obj) {
          newParameterConditionMap['标签'].push(obj?.label);
        }
      });
    }
    if (params?.authenticationFilter) {
      newParameterConditionMap['认证信息'] = [];
      params.authenticationFilter.split('$').forEach((item) => {
        const obj = searchResult?.authenticationGroup.find((row) => String(row.label) === String(item));
        if (obj) {
          newParameterConditionMap['认证信息'].push(obj?.label);
        }
      });
    }
    if (params?.queryParameterValue && aggregateResultVO?.paramNameMap) {
      params?.queryParameterValue.split('$').forEach((item) => {
        if (!newParameterConditionMap[aggregateResultVO?.paramNameMap[item.split('@@@@@')[1]]]) {
          newParameterConditionMap[aggregateResultVO?.paramNameMap[item.split('@@@@@')[1]]] = [];
        }
        newParameterConditionMap[aggregateResultVO?.paramNameMap[item.split('@@@@@')[1]]].push(item.split('@@@@@')[0]);
      });
    }
    const newParameterCondition = [];
    Object.keys(newParameterConditionMap).forEach((item) => {
      newParameterCondition.push(`${item}:${newParameterConditionMap[item].join(',')}`);
    });
    setNewParameterCondition(newParameterCondition.join('_'));
  };

  function getMoreChannel(startIndex) {
    let from = '';
    const { pathname } = location;
    if (Utils.getUrlParam('from') === 'kw') {
      from = Utils.getUrlParam('from');
    } else if (pathname.startsWith('/global.html')) {
      from = Utils.safeEncodeURI(searchResult?.globalSearchKeyword || '');
    } else if (pathname.startsWith('/brand')) {
      from = 'brand';
    } else if (pathname.startsWith('/catalog')) {
      from = 'catalog';
    }
    const paramJson = moreChannelList.slice(startIndex, startIndex + maxObserveIndex);
    if (paramJson.length === 0) {
      return;
    }
    searchMoreChannel({ from, paramJson, index: 0 }).then((res) => {
      if (res?.result && Object.keys(res?.result).length) {
        const list = [];
        const newObj = {};
        const productCodeList = [];
        Object.keys(res?.result).forEach((key) => {
          if (/\d+/.test(key)) {
            if (res?.result[key]?.length > 0) {
              res.result[key].forEach((item) => {
                list.push({
                  provider: item?.provider,
                  brandId: item?.brandId,
                });
                if (Utils.isLcBook(item?.provider)) {
                  productCodeList.push({
                    productCode: item?.productCode,
                    brandId: item?.brandId,
                  });
                }
              });
            }
            newObj[key] = res?.result[key]?.map((item) => {
              return {
                ...providerItemFormat(item),
                track_zone: res?.result?.track_zone,
              };
            });
          }
        });
        setMoreChannelVO((perv) => ({
          ...perv,
          ...newObj,
        }));
        loadMarketCouponLabelShow(productCodeList);
        setOverseaCoupon(list, true);
      }
    });
  }

  // 格式化海外代购/立创订货
  function providerItemFormat(item) {
    const aliasItem = aliasMap.get(item?.provider) || {};
    return {
      ...item,
      providerAlias: aliasItem?.providerAlias || item?.provider,
      canDetailsPage: aliasItem?.providerAlias || false,
      useSourcePartId: aliasItem?.useSourcePartId || false,
    };
  }
  const changePagination = (page) => {
    // 标记用户已进行分页操作
    setHasPaginated(true);
    changeSendSearchParams({
      currentPage: page,
    });
  };

  // 加载更多功能
  const handleLoadMore = () => {
    setDisplayCount(searchResult?.productRecordList?.length || 0);
  };

  const changeMixSortDisabled = throttle((value) => {
    setMixSortDisabled(!value);
  }, 200);

  const ArrowIcon = useMemo(() => {
    if (filterConditionHover) {
      return 'so-arrow-active';
    }
    return 'so-arrow';
  }, [filterConditionHover]);

  const unitFilterConditionList = useMemo(() => {
    return [
      ...(searchResult?.catalogGroup || []),
      ...(searchResult?.gradePlateGroup || []),
      ...(searchResult?.encapsulationGroup || []),
      ...(searchResult?.arrangeGroup || []),
      ...(searchResult?.labelGroup || []),
      ...(searchResult?.authenticationGroup || []),
    ];
  }, [
    searchResult?.catalogGroup,
    searchResult?.gradePlateGroup,
    searchResult?.encapsulationGroup,
    searchResult?.arrangeGroup,
    searchResult?.labelGroup,
    searchResult?.authenticationGroup,
  ]);

  // 判断是否显示加载更多按钮的条件
  const shouldShowLoadMore = useMemo(() => {
    const searchEngineProcess = searchResult?.searchEngineProcess;
    // 如果用户已经进行过分页操作，则不显示加载更多按钮
    if (hasPaginated) {
      return false;
    }
    return (
      (searchEngineProcess?.keywordNotFullMatch === true && searchEngineProcess?.rerankMap?.hasOvs === true) ||
      searchEngineProcess?.rerankMap?.singleBh === true
    );
  }, [
    searchResult?.searchEngineProcess?.keywordNotFullMatch,
    searchResult?.searchEngineProcess?.rerankMap?.hasOvs,
    searchResult?.searchEngineProcess?.rerankMap?.singleBh,
    hasPaginated,
  ]);

  // 计算实际显示的数据条数
  const actualDisplayCount = useMemo(() => {
    if (!shouldShowLoadMore) {
      // 如果不需要显示加载更多按钮，则显示所有数据
      return searchResult?.productRecordList?.length || 0;
    }
    // 否则使用用户设置的显示条数
    return displayCount;
  }, [shouldShowLoadMore, displayCount, searchResult?.productRecordList?.length]);

  return (
    <div className={'pt-[18px] m-auto _lg:w-[1552px] w-[1200px]'}>
      <section data-spm={'bc'} className={'_lg:w-[1340px] w-[1200px] mb-[15px] flex justify-between items-center'}>
        <Nav navList={navList} showLastArrow={false} />
        {unitFilterConditionList.length > 0 && (
          <div
            onClick={() => setShowFilterCondition(!showFilterCondition)}
            className={'flex items-center text-[14px] text-[#333333] cursor-pointer hover:text-[#0093E6]'}
            onMouseEnter={() => setFilterConditionHover(true)}
            onMouseLeave={() => setFilterConditionHover(false)}
          >
            <div className={'mr-[5px]'}>{showFilterCondition ? '收起' : '展开'}筛选</div>
            <SvgIcon
              app="so"
              iconName={ArrowIcon}
              className={`h-[6px] w-[9px] ${showFilterCondition ? 'rotate-180 transform ' : ''}`}
            />
          </div>
        )}
      </section>
      {riskMsg ? (
        <RiskMsgResult />
      ) : props?.searchResult?.productRecordList?.length > 0 || providerList?.length > 0 ? (
        <div className={'flex mx-auto shrink-0'}>
          <div className="_lg:w-[1340px] w-[1200px] relative">
            {(matchBrand || matchCatalog) && (
              <BrandAndCatalogNav isMro={isMro} matchBrand={matchBrand} matchCatalog={matchCatalog} />
            )}
            {props?.searchResult?.productRecordList?.length > 0 &&
              unitFilterConditionList.length > 0 &&
              showFilterCondition && (
                <section className={'mb-[15px]'}>
                  <FilterCondition
                    ref={filterConditionRef}
                    catalogFilters={searchResult?.catalogGroup}
                    catalogFiltersLen={props?.searchResult?.catalogGroup?.length}
                    brandFilters={searchResult?.gradePlateGroup}
                    encapFilters={searchResult?.encapsulationGroup}
                    arrangeFilters={searchResult?.arrangeGroup}
                    productTagFilters={searchResult?.labelGroup}
                    authenticationFilters={searchResult?.authenticationGroup}
                    moreOtherData={aggregateResultVO}
                    changeSendSearchParams={changeSendSearchParams}
                    sendSearchParams={sendSearchParams}
                  ></FilterCondition>
                </section>
              )}
            <section
              className={`anchor-header sticky z-[10] left-0 ${anchorHeaderCls} ${anchorHeaderShadow} bg-[#FFFFFF] rounded-[10px] mb-[15px]  _lg:w-[1340px] w-[1200px]`}
            >
              {(providerList.length > 1 || (searchResult?.totalCount > 0 && providerList.length > 0)) && (
                <AnchorNav
                  providerList={providerList}
                  totalCount={searchResult?.totalCount}
                  ref={anchorNavRef}
                  changeMixSortDisabled={changeMixSortDisabled}
                  addAnchorHeaderCls={addAnchorHeaderCls}
                />
              )}
              {props?.searchResult?.productRecordList?.length > 0 && (
                <MixSortFilter
                  totalCount={searchResult?.totalCount}
                  sendSearchParams={sendSearchParams}
                  changeSendSearchParams={changeSendSearchParams}
                  globalSearchKeyword={globalSearchKeyword}
                  hasBorder={searchResult?.totalCount > 0 || providerList.length > 0}
                  mixSortDisabled={secondQueryIsEmpty ? false : mixSortDisabled}
                  checkboxCls={secondQueryIsEmpty && !providerList?.length ? 'list-custom-checkbox' : ''}
                  isMro={mainMro}
                ></MixSortFilter>
              )}
            </section>
            {!secondQueryIsEmpty && searchResult?.productRecordList?.length > 0 && (
              <UnfoundTips
                searchEngineProcess={searchResult?.searchEngineProcess || {}}
                globalSearchKeyword={searchResult?.globalSearchKeyword || ''}
                greekCharTipList={greekCharTipList || []}
              />
            )}
            <Spin spinning={requestLoading}>
              <ProductList track_zone={props?.track_zone} searchResult={searchResult} showStockBtn={showStockBtn}>
                {!secondQueryIsEmpty &&
                  searchResult?.productRecordList.slice(0, actualDisplayCount).map((item, index) => {
                    const startIndex = (sendSearchParams?.currentPage - 1) * 30;
                    const spm = `xh${startIndex + index + 1}`;
                    let groupHeaderCls = '';
                    if (index % maxObserveIndex === 0) {
                      groupHeaderCls = 'product-group-leader ';
                    }
                    return (
                      <div
                        className={`${groupHeaderCls}relative mb-[10px] group`}
                        key={item?.productVO?.productId}
                        data-index={index}
                      >
                        <MaybeLookTag
                          mappingCodeSet={searchResult?.searchEngineProcess?.mappingCodeSet}
                          maybeLook={item?.maybeLook}
                          productCode={item?.productVO?.productCode}
                        />
                        <ProductItem
                          ref={(el) => (productItemRefs.current[index] = el)}
                          {...item}
                          moreChannelVO={moreChannelVO[item?.productVO?.productId]}
                          marketLabelVO={marketLabelVO[item?.productVO?.productId]}
                          productSpuMap={productSpuMap[item?.productVO?.productCode]}
                          productConnectorMap={productConnectorMap[item?.productVO?.productCode]}
                          osCoupon={moreOsCoupon}
                          isFavorite={favoriteList?.includes(item?.productVO?.productId)}
                          index={index}
                          rs_log={item?.rs_log}
                          spm={spm}
                          dataCustomData={JSON.stringify({
                            productType: 'main',
                            productId: item?.productVO?.productId,
                          })}
                          newParameterCondition={newParameterCondition}
                          dhAndTeAndRoCoupon={dhAndTeAndRoCoupon}
                        />
                      </div>
                    );
                  })}
                {/* 加载更多按钮 */}
                {!secondQueryIsEmpty && shouldShowLoadMore && (
                  <LoadMoreButton
                    totalCount={searchResult?.productRecordList?.length || 0}
                    displayCount={actualDisplayCount}
                    onLoadMore={handleLoadMore}
                  />
                )}
                {!secondQueryIsEmpty && paginationInfo?.countPage > 1 && (
                  <div className={'m-auto mt-[15px] mb-[60px] flex justify-center'}>
                    <CustomPagination paginationInfo={paginationInfo} changePagination={changePagination} />
                  </div>
                )}
                {secondQueryIsEmpty && <EmptyText />}
                {providerList?.map((provider, i) => (
                  <OverseasList
                    {...provider}
                    key={provider?.provider}
                    clickMore={() => getMoreProvider(provider)}
                    spm={`dg${i + 1}`}
                  >
                    {provider?.products?.map((item, index) => (
                      <OverseasCard
                        key={index}
                        data-spm={index + 1}
                        data-custom-data={JSON.stringify({
                          productType: Utils.isLcBook(provider.provider) ? 'lcBook' : 'oversea',
                          provider: provider?.provider,
                          productCodeManufacturer: item?.productCodeManufacturer,
                          sourcePartId: item?.sourcePartId,
                        })}
                      >
                        <OverseasItem
                          productVO={item}
                          osCoupon={osCoupon}
                          providerIndex={i}
                          dhAndTeAndRoCoupon={dhAndTeAndRoCoupon}
                        />
                      </OverseasCard>
                    ))}
                  </OverseasList>
                ))}
              </ProductList>
            </Spin>

            {providerList?.length > 0 && <OverseasNotice />}
          </div>
          <section className={'ml-[20px]'}>
            <FindAndStock
              ref={findAndStockRef}
              openEnquiry={openEnquiry}
              matchCatalog={matchCatalog}
              matchBrand={matchBrand}
              findAndStockContent={findAndStockContent}
              providerList={providerList}
              totalCount={searchResult?.totalCount}
            ></FindAndStock>
          </section>
        </div>
      ) : props.searchResult &&
        props.searchResult.productRecordList &&
        props.searchResult.productRecordList.length === 0 &&
        overseaLoadingFinish ? (
        <EmptyResult globalSearchKeyword={globalSearchKeyword} track_zone={props?.track_zone} />
      ) : (
        <></>
      )}
      <FloatAdvert />
      <MarketAlertDialog />
      <Toolbar wrapToTop={wrapToTop}></Toolbar>
    </div>
  );
}

export default memo(GlobalPage);
